import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient } from '@angular/common/http';

import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

import { ScoreModalComponent } from '../../../modals/score-modal/score-modal.component';

import { UserService } from '../../../services/user.service';
import { UserMenuDataService } from '../../../services/menu.service';

import *  as Classes from '../../../classes/models.classes'

import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-who-to-follow',
    templateUrl: './who-to-follow.component.html',
    styleUrls: ['./who-to-follow.component.css']
})
export class WhoToFollowComponent implements OnInit {
    //@Input() postData: any;
    @Input() UserID: number;

    @Output() hasData = new EventEmitter<boolean>();

    //@Output() reactionsUpdated = new EventEmitter<any>();

    suggestedUsers: any[] = [];

    private searchSubject = new Subject<string>();

    constructor(
        private userService: UserService,
        private userMenuDataService: UserMenuDataService,
        private router: Router,
        private modalService: NgbModal,
        private http: HttpClient
    ) {
    }

    ngOnInit() {
        this.loadSuggestedUsers();
    }

    loadSuggestedUsers() {
        this.userMenuDataService.getSuggestedUsers(this.UserID).subscribe(
            (users) => {
                this.suggestedUsers = users;
                this.hasData.emit(users.length > 0);
            },
            (error) => {
                console.error('Error loading suggested users:', error);
                this.hasData.emit(false);
            }
        );
    }

    followUser(postUserID:number, isFollowed: boolean) {
        this.userService.followUser(this.UserID, postUserID, isFollowed, false, false).subscribe({
            next: (result) => {
                console.log('User followed successfully');
            },
            error: (error) => {
                console.error('Error following the user', error);
            }
        });
    }

}
